// extracted by mini-css-extract-plugin
export default {"sidebar":"ProfileRightSidebar_sidebar__fGbwD"};